import apiService from '@/core/common/services/api.service';
import { triggerBrowserDownload } from '@/core/common/helpers/datei.utils';
import { getDokumentTypKeyFromApiValue, DOKUMENT_TYPEN } from '@/core/vorgaenge/helpers/teilnehmer-felder';

// Aktualisiert einzelne Passdaten-Felder eines Teilnehmers
export async function updateTeilnehmer(vorgangId, teilnehmerNummer, changes) {
  return apiService.patch(`/Vorgang/${vorgangId}/teilnehmer/${teilnehmerNummer}/passdaten`, changes);
}

// Lädt ein Dokument für einen Teilnehmer hoch;
export async function uploadTeilnehmerDokument(vorgangId, teilnehmerNummer, dokumentTyp, file) {
  const formData = new FormData();
  formData.append('Datei', file);
  formData.append('Type', getDokumentTypApiValue(dokumentTyp));
  const response = await apiService.post(
    `/Vorgang/${vorgangId}/teilnehmer/${teilnehmerNummer}/dokumente`,
    formData
  );
  return response.data?.result?.value ?? {};
}

// Lädt die Datei als Blob vom Server und stößt anschließend den Browser-Download an
export async function downloadTeilnehmerDokument(dokument) {
  const response = await apiService.get(
    `/Vorgang/${dokument.vorgangId}/teilnehmer/${dokument.teilnehmerNummer}/dokumente/${dokument.id}/download`,
    '',
    { responseType: 'blob' }
  );
  triggerBrowserDownload(new Blob([response.data]), dokument.dateiname);
}

export async function deleteTeilnehmerDokument(dokument) {
  return apiService.delete(
    `/Vorgang/${dokument.vorgangId}/teilnehmer/${dokument.teilnehmerNummer}/dokumente/${dokument.id}`
  );
}

// Lädt die Änderungshistorie der Passdaten eines Teilnehmers für die Verlaufsansicht
export async function getTeilnehmerHistory(vorgangId, teilnehmerNummer) {
  const response = await apiService.get(
    `/history/Vorgang/${vorgangId}/Teilnehmer/${teilnehmerNummer}/Passdaten`
  );
  return response.data?.result ?? {};
}

function getDokumentTypApiValue(dokumentTyp) {
  return DOKUMENT_TYPEN.find(typ => typ.key === dokumentTyp)?.apiValue || dokumentTyp;
}

export function normalizeDokument(dokument, vorgangId, teilnehmerNummer) {
  return {
    id: dokument.id,
    vorgangId,
    teilnehmerNummer,
    dokumentTyp: getDokumentTypKeyFromApiValue(dokument.type),
    dateiname: dokument.dateiname,
    groesse: dokument.groesse,
  };
}

// Gruppiert die Dokumente je Vorgangs-ID und darunter je Teilnehmernummer
export function groupDokumenteByVorgang(vorgaenge) {
  const map = {};
  for (const vorgang of vorgaenge || []) {
    map[vorgang.id] = (vorgang.teilnehmer || []).reduce((acc, teilnehmer) => {
      // Soft-gelöschte Dokumente werden ausgefiltert, sonst schlagen Download und Löschen fehl
      acc[teilnehmer.nummer] = (teilnehmer.dokumente || [])
        .filter(dokument => !dokument.isDeleted && dokument.deletedAt == null)
        .map(dokument => normalizeDokument(dokument, vorgang.id, teilnehmer.nummer));
      return acc;
    }, {});
  }
  return map;
}
